import React from 'react';
import { GqlLoyaltyTier } from '@fiverr-private/loyalty_utils';
import SILVER_POINTS_ICONS from './Icons/Silver';
import GOLD_POINTS_ICONS from './Icons/Gold';
import PLATINUM_POINTS_ICONS from './Icons/Platinum';
import DIAMOND_POINTS_ICONS from './Icons/Diamond';

export type LOYALTY_POINTS_ICON_SIZES = 'sm' | 'md';

interface LoyaltyBasePointsProps {
    tier: GqlLoyaltyTier;
}

interface LoyaltyMultiPointsProps extends LoyaltyBasePointsProps {
    size?: LOYALTY_POINTS_ICON_SIZES;
    type: 'multi';
}

interface LoyaltySinglePointsProps extends LoyaltyBasePointsProps {
    size?: 'sm';
    type: 'single';
}

export type LoyaltyPointsIconProps = LoyaltyMultiPointsProps | LoyaltySinglePointsProps;

type IconComponent = React.FC<{ size: LoyaltyPointsIconProps['size'] }> | React.FC;

const TIERS_POINTS_ICONS: Record<GqlLoyaltyTier, Record<LoyaltyPointsIconProps['type'], IconComponent>> = {
    SILVER: SILVER_POINTS_ICONS,
    GOLD: GOLD_POINTS_ICONS,
    PLATINUM: PLATINUM_POINTS_ICONS,
    DIAMOND: DIAMOND_POINTS_ICONS,
};

export const LoyaltyPointsIcon = ({ tier, size = 'md', type = 'multi' }: LoyaltyPointsIconProps) => {
    const Icon = TIERS_POINTS_ICONS[tier]?.[type];
    if (!Icon) return null;

    return <Icon size={size} />;
};
